<template>
  <div class="ReimbursementTab">
    <el-tabs v-model="activeName" v-toggle>
      <el-tab-pane label="全部" name="all">
        <ReimbursementTable :filterShow='filterShow' :isFinance='isFinance' @toggle='toggle' v-if="activeName==='all'" />
      </el-tab-pane>
      <el-tab-pane label="待审核" name="Pending">
        <ReimbursementTable :filterShow='filterShow' :isFinance='isFinance' :status='1' @toggle='toggle' v-if="activeName==='Pending'" />
      </el-tab-pane>
      <el-tab-pane label="已通过" name="Finished">
        <ReimbursementTable :filterShow='filterShow' :isFinance='isFinance' :status='2' @toggle='toggle' v-if="activeName==='Finished'" />
      </el-tab-pane>
      <el-tab-pane label="已驳回" name="Refused">
        <ReimbursementTable :filterShow='filterShow' :isFinance='isFinance' :status='4' @toggle='toggle' v-if="activeName==='Refused'" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>  
import ReimbursementTable from "./list.vue";
export default {
  name: "ReimbursementTab",
  components: { ReimbursementTable },
  props: ['isFinance'],
  data() {
    return {
      activeName: 'all',
      filterShow: false
    }
  },
  methods: {
    toggle(data) {
      this.$emit('toggle', data)
    }
  },
  directives: {
    toggle: {
      inserted(el, binding, { context }) {
        const headerDom = el.querySelector('.el-tabs__header')
        headerDom.style.position = 'relative'
        // 创建dom元素
        const divDom = document.createElement('div')
        divDom.style.position = 'absolute'
        divDom.style.right = '0'
        divDom.style.top = '4px'
        // 创建子元素span
        const spanDom = document.createElement('span')
        spanDom.addEventListener('click', () => {
          context.filterShow = !context.filterShow
        })
        // 创建图标
        const iDom = document.createElement('i')
        // 设置类名(已有全局样式)
        divDom.setAttribute('class', 'pageHead')
        spanDom.setAttribute('class', 'search')
        iDom.setAttribute('class', 'el-icon-search')
        //  插入元素
        spanDom.appendChild(iDom)
        divDom.appendChild(spanDom)
        headerDom.appendChild(divDom)
      }
    }
  }
}
</script>
<style lang="less" scoped>
.ReimbursementTab {
  height: 100%;
  background-color: #fff;
  padding: 0 16px;
  :deep(.pageHead) {
    border-bottom: none;
    padding: 0;
    margin: 0;
    right: 0;
  }
}
</style>